import React from "react";
import { Carousel, Button } from "react-bootstrap";
import video1 from "../../assets/videos/videos.mp4";
import { useNavigate } from "react-router-dom";

const MyCarousel: React.FC = () => {
  const navigate = useNavigate();

  const handleApply = () => {
    navigate("/apply");
  };

  const slides = [
    {
      video: video1,
      subtitle: "We Are Hiring – VLSI Drive",
      title: "Roles: Physical Design, Design Verification",
      desc: "Trained freshers (before 2021 passed out)",
    },
    {
      video: video1,
      subtitle: "VLSI Career Opportunities",
      title: "Roles: DFT, STA / Synthesis, Analog Layout",
      desc: "Freshers & Experienced Candidates",
    },
  ];

  return (
    <Carousel fade interval={4000} controls indicators>
      {slides.map((slide, index) => (
        <Carousel.Item key={index}>
          <div className="carousel-wrapper">
            
            {/* ✅ VIDEO INSTEAD OF IMAGE */}
            <video
              className="d-block w-100 carousel-img"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={slide.video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <div className="carousel-overlay" />

            <Carousel.Caption className="carousel-content">
              <h6>{slide.subtitle}</h6>
              <h2>{slide.title}</h2>
              <p>{slide.desc}</p>

              <Button className="carousel-btn" onClick={handleApply}>
                APPLY NOW →
              </Button>
            </Carousel.Caption>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default MyCarousel;